import * as React from 'react';
import classNames from 'classnames';
import {Text, TextColors} from '@discordapp/design/web';

import styles from './FormLabel.module.css';

interface Props {
  children: React.ReactNode;
  id?: string;
  color?: TextColors;
  isFlush?: boolean;
  isRequired?: boolean;
  className?: string;
  htmlFor?: string;
}

const FormLabel = ({
  children,
  id,
  color = 'text-normal',
  isFlush = false,
  isRequired = false,
  className,
  htmlFor,
}: Props) => (
  <Text
    id={id}
    variant="eyebrow"
    className={classNames(styles.label, {[styles.flush]: isFlush}, className)}
    color={color}
    htmlFor={htmlFor}
    tag="label">
    {children}
    {isRequired && <span className={styles.requiredIndicator}> *</span>}
  </Text>
);

export default FormLabel;
